import './App.css';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home.js';
import Login from './pages/Login/LoginPage.jsx';
import Unauthorized from './pages/Unauthorized/Unauthorized.jsx';
import ProtectedRoute from './pages/components/ProtectedRoute.js';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword/ResetPassword.jsx';

// Public component
import RemoteSignature from './pages/components/RemoteSignature.js';

// User Management
import UserPage from './pages/UserManagement/UserPage.jsx';
import UserListPage from './pages/UserManagement/UserListPage.jsx';
// Role Management
import RolePage from './pages/RoleManagement/RolePage.jsx';
import RoleListPage from './pages/RoleManagement/RoleListPage.jsx';
import PermissionManagement from './pages/RoleManagement/PermissionManagement.jsx';

// Patient Management
import PatientPage from './pages/PatientManagement/PatientPage.jsx';
import PatientListPage from './pages/PatientManagement/PatientListPage.jsx';
import MainPage from './pages/MainPage.js';
// Inventory Management
import InventoryPage from './pages/InventoryManagement/InventoryPage.jsx';
import InventoryListPage from './pages/InventoryManagement/InventoryListPage.jsx';
// OT Management
import OTBooking from './pages/OTManagement/OTBookingList/OTBookingList.jsx';
import OTBookingPage from './pages/OTManagement/OTBookingPage.jsx';
import OTRooms from './pages/OTManagement/OTRooms/OTRooms.jsx';
// Feedback Management
import FeedbackPage from './pages/FeedbackManagement/FeedbackPage.jsx';
import FeedbackListPage from './pages/FeedbackManagement/FeedbackListPage.jsx';
import VideoRecorder from './pages/components/videorecorder.js';
import AddFile from './pages/AddFile/AddFilePage.jsx';

// Pre-operative

import ConsentForAnaestnesia from './pages/PreOperative/consentForAnaesthesia/ConsentForAnaesthesia';
import ConsentForMedical from './pages/PreOperative/consentForm/ConsentForm';
import SurgicalSafetyChecklist from './pages/PreOperative/surgicalSafetyChecklist/SurgicalSafetyChecklist';


import HighRiskConsentForm from './pages/PreOperative/highRiskConsent/HighRiskConsentForm';
import PreOperativeChecklist from './pages/PreOperative/preOpChecklist/PreOperativeChecklist';
import ConfirmationPhase from './pages/PreOperative/confirmationPhase/ConfirmationPhase';
import PreoperativeOrders from './pages/PreOperative/preOpOrders/PreOperativeOrders';
import PreAnaestheticForm from './pages/PreOperative/preAnaestheticForm/PreAnaestheticForm';
// Intra-operative

import IntraOperativeNursingRecord from './pages/IntraOperative/intraOperativeNursingRecord/IntraOperativeNursingRecord.js';
import OperationSheet from './pages/IntraOperative/operationSheet/OperationSheet.js';
import IntraPostOperativeOrders from './pages/PostOperative/postOpOrders/PostOperativeOrders';

// Post-operative
import PostOperative from './pages/PostOperative/postOperativeHub/PostOperativeHub';
import AldreteScore from './pages/PostOperative/aldreteScore/AldreteScore';
import PostOperativeHandover from './pages/PostOperative/postOpHandover/PostOperativeHandover';
import PostOperativeInstructions from './pages/PostOperative/postOpInstructions/PostOperativeInstructions';
import PostOperativeTable from './pages/PostOperative/analgesiaAssessment/AnalgesiaAssessmentChart';


// Other
import ConsiderationPhase from './pages/ConsiderationPhase/considerationPhase/ConsiderationPhase.js';

import AnesthesiaForm from './pages/PreOperative/anesthesiaForm/AnesthesiaForm';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path='/' element={<Login />} />
      <Route path='/login' element={<Login />} />
      <Route path='/unauthorized' element={<Unauthorized />} />

      <Route path="/forgot_password" element={<ForgotPassword />} />
      <Route path="/reset_password/:token" element={<ResetPassword />} />


      {/* Admin-only Routes */}
      <Route
        path='/addUser'
        element={
          <ProtectedRoute allowedPermissions={['Users Add']}>
            <UserPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editUser/:user_id'
        element={
          <ProtectedRoute allowedPermissions={['Users Edit']}>
            <UserPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/user'
        element={
          <ProtectedRoute allowedPermissions={['Users View']}>
            <UserListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addRole'
        element={
          <ProtectedRoute allowedPermissions={['Roles Add']}>
            <RolePage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editRole/:role_id'
        element={
          <ProtectedRoute allowedPermissions={['Roles Edit']}>
            <RolePage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/roleList'
        element={
          <ProtectedRoute allowedPermissions={['Roles View']}>
            <RoleListPage />
          </ProtectedRoute>
        }
      />

      {/* Shared Protected Routes (Admin + Nurse) */}
      <Route
        path='/home'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path='/video'
        element={
          <ProtectedRoute allowedPermissions={['Dashboard View']}>
            <VideoRecorder />
          </ProtectedRoute>
        }
      />
      <Route
        path='/signature-form/:uhid/:token'
        element={
          <ProtectedRoute allowedPermissions={['Consents Edit']}>
            <RemoteSignature />
          </ProtectedRoute>
        }
      />

      <Route
        path='/addPatient'
        element={
          <ProtectedRoute allowedPermissions={['Patients Add']}>
            <PatientPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editPatient/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Patients Edit']}>
            <PatientPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/listPatient'
        element={
          <ProtectedRoute allowedPermissions={['Patients View']}>
            <PatientListPage />
          </ProtectedRoute>
        }
      />

      <Route
        path='/preoperativeorders/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Op Orders View']}>
            <PreoperativeOrders />
          </ProtectedRoute>
        }
      />
      <Route
        path='/preInductionAssessment/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Anaesthetic Evaluation View']}>
            <AnesthesiaForm />
          </ProtectedRoute>
        }
      />
      <Route
        path='/mainPage/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <MainPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addInventory'
        element={
          <ProtectedRoute allowedPermissions={['Inventory Add']}>
            <InventoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editInventory/:item_id'
        element={
          <ProtectedRoute allowedPermissions={['Inventory Edit']}>
            <InventoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/listInventory'
        element={
          <ProtectedRoute allowedPermissions={['Inventory View']}>
            <InventoryListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otRooms'
        element={
          <ProtectedRoute allowedPermissions={['OT Rooms View']}>
            <OTRooms />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otBooking'
        element={
          <ProtectedRoute allowedPermissions={['OT Booking View']}>
            <OTBooking />
          </ProtectedRoute>
        }
      />

      <Route
        path='/addOtBooking'
        element={
          <ProtectedRoute allowedPermissions={['OT Booking Add']}>
            <OTBookingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editOtBooking/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['OT Booking Edit']}>
            <OTBookingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addFeedback'
        element={
          <ProtectedRoute allowedPermissions={['Patient Feedback Add']}>
            <FeedbackPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/listFeedback'
        element={
          <ProtectedRoute allowedPermissions={['Patient Feedback View']}>
            <FeedbackListPage />
          </ProtectedRoute>
        }
      />

      {/* Pre-Operative Routes */}

      <Route
        path='/consentForAnaesthesia/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Consents View']}>
            <ConsentForAnaestnesia />
          </ProtectedRoute>
        }
      />
      <Route
        path='/consentForMedical/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Consents View']}>
            <ConsentForMedical />
          </ProtectedRoute>
        }
      />
      <Route
        path='/surgicalSafetyChecklist/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Surgical Safety Checklist View']}>
            <SurgicalSafetyChecklist />
          </ProtectedRoute>
        }
      />
      <Route
        path='/preAnaestheticForm/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Anaesthetic Evaluation View']}>
            <PreAnaestheticForm />
          </ProtectedRoute>
        }
      />
      {/* <Route
      //   path='/preAnaestheticForm/:uhid_no'
      //   element={
      //     <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
      //       <PreAnaestheticForm />
      //     </ProtectedRoute>
      //   }
      // />
      <Route
        path='/2'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PreAnaestheticForm2 />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path='/highRiskConsentForm/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Consents View']}>
            <HighRiskConsentForm />
          </ProtectedRoute>
        }
      />
      <Route
        path='/preOperativeChecklist/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Op Checklist View']}>
            <PreOperativeChecklist />
          </ProtectedRoute>
        }
      />
      <Route
        path='/confirmationPhase/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Op Checklist View']}>
            <ConfirmationPhase />
          </ProtectedRoute>
        }
      />

      {/* Intra-Operative Routes */}

      <Route
        path='/intraOperativeNursingRecord/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Nursing Record View']}>
            <IntraOperativeNursingRecord />
          </ProtectedRoute>
        }
      />
      <Route
        path='/operationSheet/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Operation Sheet View']}>
            <OperationSheet />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeOrders/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Orders View']}>
            <IntraPostOperativeOrders />
          </ProtectedRoute>
        }
      />

      {/* Post-Operative Routes */}
      <Route
        path='/postOperative/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Orders View']}>
            <PostOperative />
          </ProtectedRoute>
        }
      />
      <Route
        path='/aldreteScore/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Alderete Score View']}>
            <AldreteScore />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeHandover/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Handover View']}>
            <PostOperativeHandover />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeInstructions/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Instructions View']}>
            <PostOperativeInstructions />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeAssesment/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Instructions View']}>
            <PostOperativeTable />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addfile/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Patients Edit']}>
            <AddFile />
          </ProtectedRoute>
        }
      />


      <Route
        path='/considerationPhase/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Consents View']}>
            <ConsiderationPhase />
          </ProtectedRoute>
        }
      />
      <Route
        path='/roleManagement'
        element={
          <ProtectedRoute allowedPermissions={['Roles View']}>
            <PermissionManagement />
          </ProtectedRoute>
        }
      />
      {/* Catch-all route redirects to login */}
      <Route path="*" element={<Login />} />
    </Routes>
  );
}

export default App;
